// TODO: VL-6033 - re-write the vl_chat FE by FE engineers
/**
 * Utility functions for CopilotKit custom components
 */

/**
 * Extract initials from a full name
 * @param name - Full name of the user
 * @returns Initials (max 2 characters)
 */
export function getInitials(name: string | undefined | null): string {
  if (!name) return 'U';
  
  const cleanName = name.trim();
  if (!cleanName) return 'U';
  
  const parts = cleanName.split(/\s+/).filter(Boolean);
  
  if (parts.length === 0) return 'U';
  
  if (parts.length === 1) {
    // Single word name - take first two letters
    return parts[0].substring(0, 2).toUpperCase();
  } else {
    // Multiple words - take first letter of first and last word
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
}

/**
 * Generate a consistent color based on a string (e.g., user name)
 * Uses HSL to ensure good contrast and readability
 * @param str - String to generate color from
 * @returns HSL color string
 */
export function generateColorFromString(str: string | undefined | null): string {
  if (!str) return 'hsl(220, 70%, 50%)'; // Default blue
  
  // Simple hash function to generate a number from string
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  
  // Convert to HSL with good saturation and lightness for readability
  const hue = Math.abs(hash) % 360;
  const saturation = 65 + (Math.abs(hash) % 20); // 65-85%
  const lightness = 45 + (Math.abs(hash) % 10); // 45-55%
  
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}

/**
 * Get avatar background color for a user
 * @param userName - User's name
 * @returns CSS color string
 */
export function getAvatarColor(userName: string | undefined | null): string {
  return generateColorFromString(userName);
}

/**
 * Get user's email from name (if it looks like an email)
 * @param name - User's name or email
 * @returns Email if found, otherwise null
 */
export function extractEmailFromName(name: string | undefined | null): string | null {
  if (!name) return null;
  
  // Check if the name itself is an email
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (emailRegex.test(name)) {
    return name;
  }
  
  // Check if the name contains an email in parentheses or brackets
  const emailInBrackets = name.match(/[<(]([^\s@]+@[^\s@]+\.[^\s@]+)[>)]/);
  if (emailInBrackets) {
    return emailInBrackets[1];
  }
  
  return null;
}

/**
 * Get display name from a user object or string
 * @param user - User object or string
 * @returns Display name
 */
export function getDisplayName(user: any): string {
  if (!user) return 'User';
  
  if (typeof user === 'string') {
    // If it's an email, extract the part before @
    const email = extractEmailFromName(user);
    if (email) {
      return email.split('@')[0];
    }
    return user;
  }
  
  // If it's an object, try to get name, username, or email
  return user.name || user.username || user.email || 'User';
}